import { View } from "react-native";
import type { LucideIcon } from "lucide-react-native";
import { SectionTitle } from "@louise/moon-ui/primitives/SectionTitle";

type Props = {
  children: string;
  icon?: LucideIcon;
};

export default function DetailSectionTitle({ children, icon }: Props) {
  return (
    <View style={{ marginBottom: 10 }}>
      <SectionTitle icon={icon}>{children}</SectionTitle>
    </View>
  );
}
